import * as yup from 'yup';
import { Row, RenderConfig, TextInput, AssetUploadInputOnS3, ASSET_TYPE, SelectInput, TextAreaInput } from 'commons-ui';
import { TICKET_OPTIONS } from './constants';

export const FORM_FIELD_KEYS = {
	AGENT_ID: 'agentId',
	AGENT_REPLY: 'agentReply',
	TICKET_STATUS: 'ticketStatus',
	TICKETS_ID_CSV: 'ticketsIdCsv'
};

export const validationSchema = yup.object().shape({
	agentId: yup.number().required('Agent Id is a required field'),
	agentReply: yup.string().required('Agent reply is a required field'),
	ticketStatus: yup.string().required('Ticket status is a required field'),
	csvUrl: yup.string().required('Csv file is required')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.AGENT_ID]: new RenderConfig()
		.setName('agentId')
		.setLabel('Agent Id')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),
	[FORM_FIELD_KEYS.AGENT_REPLY]: new RenderConfig()
		.setName('agentReply')
		.setLabel('Agent Reply')
		.setRenderer(TextAreaInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),
	[FORM_FIELD_KEYS.TICKET_STATUS]: new RenderConfig()
		.setName('ticketStatus')
		.setLabel('Ticket Status')
		.setRenderer(SelectInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, options: TICKET_OPTIONS, required: true }),
	[FORM_FIELD_KEYS.TICKETS_ID_CSV]: new RenderConfig()
		.setName('csvUrl')
		.setLabel('Tickets Id CSV')
		.setRenderer(AssetUploadInputOnS3)
		.setRenderProps({ isEditable: { create: true, edit: false }, assetType: ASSET_TYPE.MEDIA_PRIVATE })
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.AGENT_ID),
	new Row(FORM_FIELD_KEYS.AGENT_REPLY),
	new Row(FORM_FIELD_KEYS.TICKET_STATUS),
	new Row(FORM_FIELD_KEYS.TICKETS_ID_CSV)
];
